var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcarefonedeleteN(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D8F6E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.667l-4-2L22 10l-3.333 11.333-5.334-2m0 0L16.667 16m-3.334 3.333v3.334",
    stroke: "#3ECF8E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTYiIGZpbGw9IiNEOEY2RTUiLz4KPHBhdGggZD0iTTEyIDE4LjY2NjdMOCAxNi42NjY3TDIyIDEwTDE4LjY2NjcgMjEuMzMzM0wxMy4zMzMzIDE5LjMzMzNNMTMuMzMzMyAxOS4zMzMzTDE2LjY2NjcgMTZNMTMuMzMzMyAxOS4zMzMzVjIyLjY2NjciIHN0cm9rZT0iIzNFQ0Y4RSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgIcarefonedeleteN as ReactComponent };